export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8792.9578c9d6.jpg";